import React from "react";
import PathConstants from "./pathConstants";
import { ResourceTypes } from "../constants/enums";
import PrivateRoutes from "../component/routes/PrivateRoutes";

const HomePage = React.lazy(() => import("../pages/home/index"));
const AboutUsPage = React.lazy(() => import("../pages/about-us/index"));
const ContactUsPage = React.lazy(() => import("../pages/contact-us/index"));
const AchievementsAndStatisticsPage = React.lazy(
    () => import("../pages/achievements-and-statistics/index")
);
const AchievementsPage = React.lazy(() => import("../pages/achievements/index"));
const SuccessStoryDetailsPage = React.lazy(
    () => import("../pages/success-story-details/index")
);
const NaqshPlatformDonationPage = React.lazy(
    () => import("../pages/naqsh-platform-donation/index")
);
const ProjectsPage = React.lazy(() => import("../pages/projects/index"));
const PartnersPage = React.lazy(() => import("../pages/partners/index"));
const TeamPage = React.lazy(() => import("../pages/team/index"));
const PartnersAndTeamPage = React.lazy(
    () => import("../pages/partners-and-team/index")
);
const ActiveCampaignsPage = React.lazy(
    () => import("../pages/active-campaigns/index")
);
const DetailsPage = React.lazy(
    () => import("../pages/details-page/index")
);
const DonatePage = React.lazy(() => import("../pages/donate/index"));
const SuccessPaymentPage = React.lazy(
    () => import("../pages/success-payment/index")
);
const FailPaymentPage = React.lazy(
    () => import("../pages/fail-payment/index")
);
const LoginPage = React.lazy(() => import("../pages/auth/login/index"));
const RegisterPage = React.lazy(() => import("../pages/auth/register/index"));
const VerifyAccountPage = React.lazy(
    () => import("../pages/auth/verify-account/index")
);
const ForgotPasswordPage = React.lazy(
    () => import("../pages/auth/forgot-password/index")
);
const VerifyForgotPasswordPage = React.lazy(
    () => import("../pages/auth/verify-forgot-password/index")
);
const ResetPasswordPage = React.lazy(
    () => import("../pages/auth/reset-password/index")
);
const ProfilePage = React.lazy(() => import("../pages/profile/index"));
const routes = [
    { path: PathConstants.HOME, element: <HomePage /> },
    { path: PathConstants.ABOUT_US, element: <AboutUsPage /> },
    { path: PathConstants.CONTACT_US, element: <ContactUsPage /> },
    {
        path: PathConstants.ACHIEVEMENTS_AND_STATISTICS,
        element: <AchievementsAndStatisticsPage />,
    },
    { path: PathConstants.ACHIEVEMENTS, element: <AchievementsPage /> },
    {
        path: PathConstants.SUCCESS_STORY_DETAILS,
        element: <SuccessStoryDetailsPage />,
    },
    {
        path: PathConstants.NAQSH_PLATFORM_DONATION,
        element: <NaqshPlatformDonationPage />,
    },
    { path: PathConstants.PARTNERS_AND_TEAM, element: <PartnersAndTeamPage /> },
    { path: PathConstants.PARTNERS, element: <PartnersPage /> },
    { path: PathConstants.TEAM, element: <TeamPage /> },
    // Projects
    { path: PathConstants.PROJECTS, element: <ProjectsPage /> },
    { path: PathConstants.PROJECT_DETAILS, element: <DetailsPage type={ResourceTypes.PROJECT} /> },
    // Campaigns
    { path: PathConstants.ACTIVE_CAMPAIGNS, element: <ActiveCampaignsPage /> },
    { path: PathConstants.CAMPAIGN_DETAILS, element: <DetailsPage type={ResourceTypes.CAMPAIGN} /> },
    // Donate
    { path: PathConstants.DONATE_PLATFORM, element: <DonatePage type={ResourceTypes.PLATFORM} /> },
    { path: PathConstants.DONATE, element: <DonatePage /> },
    { path: PathConstants.SUCCESS_DONATION, element: <SuccessPaymentPage /> },
    { path: PathConstants.FAIL_DONATION, element: <FailPaymentPage /> },
    // Auth
    { path: PathConstants.LOGIN, element: <LoginPage /> },
    { path: PathConstants.REGISTER, element: <RegisterPage /> },
    { path: PathConstants.VERIFY_ACCOUNT, element: <VerifyAccountPage /> },
    { path: PathConstants.FORGOT_PASSWORD, element: <ForgotPasswordPage /> },
    {
        path: PathConstants.VERIFY_FORGOT_PASSWORD,
        element: <VerifyForgotPasswordPage />,
    },
    { path: PathConstants.RESET_PASSWORD, element: <ResetPasswordPage /> },
    {
        element: <PrivateRoutes />,
        children: [
            { path: PathConstants.PROFILE, element: <ProfilePage /> },
        ],
    },

];

export default routes;
